import {
    ADD_THEME,
    ADD_THEME_SUCCESS,
    ADD_THEME_FAILURE,
    EDIT_THEME,
    EDIT_THEME_FAILURE,
    EDIT_THEME_SUCCESS,
    THEMES_LIST,
    THEMES_LIST_FAILURE,
    THEMES_LIST_SUCCESS,
    UPDATE_THEME_ORDER_STATUS,
    UPDATE_THEME_ORDER_STATUS_FAILURE,
    UPDATE_THEME_ORDER_STATUS_SUCCESS,
    UPDATE_THEME_STATUS,
    UPDATE_THEME_STATUS_FAILURE,
    UPDATE_THEME_STATUS_SUCCESS,
    DELETE_THEME,
    DELETE_THEME_SUCCESS,
    DELETE_THEME_FAILURE
} from "../Constants";

import {  } from "../Constants";

export const ThemeList = (payload) => ({
    type: THEMES_LIST,
    payload
});

export const ThemeListSuccess = (payload) => ({
    type: THEMES_LIST_SUCCESS,
    payload
});

export const ThemeListFailure = (payload) => ({
    type: THEMES_LIST_FAILURE,
    payload
});

export const AddTheme = (payload) => ({
    type: ADD_THEME,
    payload
});

export const AddThemeSuccess = (payload) => ({
    type: ADD_THEME_SUCCESS,
    payload
});

export const AddThemeFailure = (payload) => ({
    type: ADD_THEME_FAILURE,
    payload
});

export const UpdateThemeStatus = (payload) => ({
    type: UPDATE_THEME_STATUS,
    payload
});

export const UpdateThemeStatusSuccess = (payload) => ({
    type: UPDATE_THEME_STATUS_SUCCESS,
    payload
});

export const UpdateThemeStatusFailure = (payload) => ({
    type: UPDATE_THEME_STATUS_FAILURE,
    payload
});

export const EditTheme = (payload) => ({
    type: EDIT_THEME,
    payload
});

export const EditThemeSuccess = (payload) => ({
    type: EDIT_THEME_SUCCESS,
    payload
});

export const EditThemeFailure = (payload) => ({
    type: EDIT_THEME_FAILURE,
    payload
});

export const UpdateThemeOrderStatus = (payload) => ({
    type: UPDATE_THEME_ORDER_STATUS,
    payload
});

export const UpdateThemeOrderStatusSuccess = (payload) => ({
    type: UPDATE_THEME_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateThemeOrderStatusFailure = (payload) => ({
    type: UPDATE_THEME_ORDER_STATUS_FAILURE,
    payload
});

export const deleteTheme = (payload) => ({
    type: DELETE_THEME,
    payload
});

export const deleteThemeSuccess = (payload) => ({
    type: DELETE_THEME_SUCCESS,
    payload
});

export const deleteThemeFailure = (payload) => ({
    type: DELETE_THEME_FAILURE,
    payload
});